import { buildProps } from '@sgui-plus/utils/props'
import { radioProps, radioEmits } from './radio'
import type { ExtractPropTypes } from 'vue'

export const radioButtonProps = buildProps({
  ...radioProps, 
} as const)

export type RadioButtonProps = ExtractPropTypes<typeof radioButtonProps>
export const radioButtonEmits = radioEmits
